var map = {
	"./barn_owl_hoot.mp3": 3879,
	"./eagle_owl_hoot.mp3": 3880,
	"./elf_owl_hoot.mp3": 3881,
	"./horned_owl_hoot.mp3": 3882,
	"./screech_owl_hoot.mp3": 3883,
	"./snowy_owl_hoot.mp3": 3884
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 686;



//////////////////
// WEBPACK FOOTER
// ./assets/sounds/owl-hoots .\.mp3*
// module id = 686
// module chunks = 0